export enum HotelWebUrlType {
  STATIC = 'Static',
  HOTEL = 'Hotel',
  HOTEL_CITY = 'HotelCity',
  HOTEL_REGION = 'HotelRegion',
  HOTEL_THEME = 'HotelTheme',
  HOTEL_CHAIN = 'HotelChain',
}
